import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, unref as _unref, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["disabled", "aria-haspopup", "aria-expanded"];
const _hoisted_2 = {
    key: 1,
    class: "rec-list-item__checkbox-item"
};
const _hoisted_3 = ["value", "checked"];
const _hoisted_4 = {
    key: 0,
    class: "rec-list-item__sub-label"
};
const _hoisted_5 = {
    key: 3,
    class: "rec-flyout-indicator"
};
import { computed, nextTick, onMounted, onUnmounted, ref, toRef, useTemplateRef, watch, watchEffect } from "vue";
import { useActiveElement, useElementBounding, useElementHover, useVModel } from "@vueuse/core";
import { useDropdownAccessibility } from "@/common/composables/dropdown-accessibility";
// Types & Enums
import { MenuItemType } from "@/common/composables/dropdown-accessibility";
// Components
import SelectorMenu from "./SelectorMenu.vue";
import SvgIcon from "@/common/components/SvgIcon.vue";
import { TypeIcon } from "../types";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SelectorOption',
    props: {
        modelValue: {},
        option: {},
        parentOption: {},
        multiple: { type: Boolean },
        collapseSubMenu: { type: Boolean },
        hoveredOption: {},
        parentMenu: {},
        menuToggleBtn: {}
    },
    emits: ["update:modelValue", "hover", "unhover"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const subMenuButtonRef = useTemplateRef("subMenuButtonRef");
        const subMenuRef = useTemplateRef("subMenuRef");
        const parentMenuRef = toRef(props, "parentMenu");
        const menuToggleBtnRef = toRef(props, "menuToggleBtn");
        const activeElement = useActiveElement();
        const parentRef = computed(() => subMenuButtonRef.value?.parentElement);
        const isElementVisible = ref(false);
        const submenuVisible = ref(false);
        const toggleSubMenu = () => {
            submenuVisible.value = !submenuVisible.value;
            if (submenuVisible.value) {
                nextTick(() => {
                    buttonBounds.update();
                    menuBounds.update();
                });
            }
        };
        watchEffect(() => {
            if (activeElement.value === subMenuButtonRef.value) {
                submenuVisible.value = false;
            }
        });
        const checkVisibility = () => {
            if (subMenuButtonRef.value) {
                // Get the parent element
                if (!parentRef.value)
                    return;
                const elementRect = subMenuButtonRef.value.getBoundingClientRect();
                const parentRect = parentRef.value.getBoundingClientRect();
                // Check if the element is within the parent's visible area
                isElementVisible.value =
                    elementRect.bottom > parentRect.top && // Element's bottom is below parent's top
                        elementRect.top < parentRect.bottom && // Element's top is above parent's bottom
                        elementRect.right > parentRect.left && // Element's right is to the right of parent's left
                        elementRect.left < parentRect.right; // Element's left is to the left of parent's right
            }
        };
        // Scroll the selected option into view
        const scrollToSelectedOption = () => {
            nextTick(() => {
                if (subMenuButtonRef.value) {
                    subMenuButtonRef.value.scrollIntoView({
                        behavior: "smooth", // Smooth scrolling
                        block: "center" // Scroll to the center
                    });
                }
            });
        };
        // Add and remove scroll event listeners
        onMounted(() => {
            const parent = subMenuButtonRef.value?.parentElement;
            if (parent) {
                parent.addEventListener("scroll", checkVisibility, { passive: true });
                checkVisibility(); // Initial check
            }
            if (optionSelected.value) {
                scrollToSelectedOption();
            }
        });
        onUnmounted(() => {
            const parent = subMenuButtonRef.value?.parentElement;
            if (parent) {
                parent.removeEventListener("scroll", checkVisibility);
            }
        });
        const model = useVModel(props, "modelValue");
        const emit = __emit;
        const value = computed(() => {
            if (model.value && "ids" in model.value) {
                return { id: model.value.ids?.find((id) => id == props.option.id) };
            }
            return model.value;
        });
        const subChoice = computed({
            get: () => (optionSelected.value ? value.value?.subChoice : undefined),
            set: (val) => {
                if (val) {
                    const value = { id: props.option.id, subChoice: val };
                    if (props.multiple && (model.value == undefined || model.value.ids == undefined)) {
                        model.value = { ids: [] };
                    }
                    if (model.value && "ids" in model.value && model.value.ids !== undefined) {
                        model.value.ids.push(value.id);
                    }
                    else {
                        model.value = value;
                    }
                }
            }
        });
        const optionSelected = computed(() => {
            if (props.parentOption == undefined) {
                return value.value?.id == props.option.id;
            }
            else {
                return value.value?.id == props.parentOption?.id && value.value?.subChoice?.id == props.option.id;
            }
        });
        const hasSubMenu = computed(() => props.option.subOptions != undefined &&
            props.option.subOptions.length > 0 &&
            (!props.collapseSubMenu ||
                props.option.subOptions.length > 1 ||
                props.option.subOptions[0]?.subOptions != undefined));
        const toggleOption = () => {
            subMenuButtonRef.value?.blur();
            const optionId = props.option.id;
            if (props.parentOption) {
                const isSelected = model.value &&
                    "subChoice" in model.value &&
                    model.value.id === props.parentOption.id &&
                    model.value.subChoice?.id === optionId;
                model.value = isSelected
                    ? undefined
                    : {
                        id: props.parentOption.id,
                        subChoice: { id: optionId }
                    };
                return;
            }
            if (hasSubMenu.value) {
                nextTick(() => {
                    buttonBounds.update();
                    menuBounds.update();
                });
            }
            const value = { id: optionId };
            if (props.multiple) {
                const currentIds = model.value && "ids" in model.value && Array.isArray(model.value.ids) ? [...model.value.ids] : [];
                const index = currentIds.indexOf(optionId);
                if (index !== -1) {
                    currentIds.splice(index, 1); // Deselect
                }
                else {
                    currentIds.push(optionId); // Select
                }
                model.value = { ids: currentIds };
            }
            else {
                const isSelected = model.value?.id === optionId;
                model.value = isSelected ? undefined : value;
            }
        };
        const isSubMenuHovered = useElementHover(subMenuRef);
        const isOptionHovered = useElementHover(subMenuButtonRef, { delayLeave: 100 });
        // Position the menu
        const buttonBounds = useElementBounding(subMenuButtonRef);
        const menuBounds = useElementBounding(subMenuRef);
        const parentBounds = useElementBounding(parentRef);
        watch(parentBounds.top, (newBounds) => {
            if (newBounds) {
                let runtime = 0;
                const update = () => {
                    buttonBounds.update();
                    menuBounds.update();
                    runtime++;
                    if (runtime < 20) {
                        setTimeout(update, 5);
                    }
                };
                setTimeout(update, 5);
            }
        });
        const menuStyle = computed(() => {
            const menuPadding = 12;
            const viewportHeight = window.innerHeight;
            const viewportWidth = window.innerWidth;
            // These values will be updated and used to position the menu
            let top = buttonBounds.top.value - menuPadding;
            let left = buttonBounds.left.value;
            let maxHeight;
            const width = buttonBounds.width.value;
            const spaceAbove = buttonBounds.top.value - menuPadding;
            const spaceBelow = viewportHeight - (buttonBounds.top.value + buttonBounds.height.value) - menuPadding;
            const height = viewportHeight - (spaceAbove < spaceBelow ? spaceAbove : spaceBelow) - menuPadding;
            // Ensure menu does not overflow the viewport vertically
            if (top + menuBounds.height.value + menuPadding >= viewportHeight) {
                if (spaceAbove > spaceBelow) {
                    top = buttonBounds.top.value - menuBounds.height.value + buttonBounds.height.value + menuPadding;
                }
                if (top < 0) {
                    top = menuPadding;
                }
                // Check if menu overflows bottom
                if (menuBounds.height.value >= height) {
                    maxHeight = `${height}px`;
                }
            }
            // Ensure menu does not overflow the viewport horizontally
            if (left + width + menuBounds.width.value >= viewportWidth) {
                // If the menu overflows the right side, position it to the left of the button
                left = left - width;
            }
            else {
                // If it fits, position it to the right of the button
                left = buttonBounds.right.value;
            }
            // If the left position is negative, adjust it to be within the viewport
            if (left < 0) {
                left = buttonBounds.left.value + 20;
                // When menus overlap, we want to position the sub-menu above or below the button
                // depending on the available space
                if (spaceAbove > spaceBelow) {
                    top = buttonBounds.top.value - menuBounds.height.value;
                }
                else {
                    top = buttonBounds.top.value + buttonBounds.height.value;
                }
            }
            const style = {
                top: `${top}px`,
                left: `${left}px`,
                width: `${width}px`,
                ...(maxHeight && { maxHeight: `min(${maxHeight}, 25rem)` })
            };
            return style;
        });
        const buttonClasses = computed(() => {
            return {
                "rec-list-item": true,
                "rec-list-item--active": optionSelected.value,
                "rec-list-item--flyout": hasSubMenu.value && !props.option.disabled
            };
        });
        const iconType = computed(() => (props.option.type ? TypeIcon[props.option.type] : undefined));
        const showSubMenu = computed(() => !props.option.disabled &&
            hasSubMenu.value &&
            isElementVisible.value &&
            ((optionSelected.value && !anotherHover.value) || hovered.value || submenuVisible.value));
        const anotherHover = computed(() => props.hoveredOption != undefined && props.hoveredOption.id != props.option.id);
        const hovered = computed(() => isSubMenuHovered.value || isOptionHovered.value);
        watch(hovered, (isHovered) => {
            if (isHovered) {
                emit("hover", props.option);
            }
            else {
                emit("unhover", props.option);
            }
        });
        watch(showSubMenu, (newValue) => {
            if (newValue) {
                nextTick(() => {
                    buttonBounds.update();
                    menuBounds.update();
                });
            }
        });
        watchEffect((onCleanup) => {
            const disposeEventListener = useDropdownAccessibility({
                isOpen: showSubMenu,
                submenu: subMenuRef,
                menu: parentMenuRef,
                eventTargetEl: subMenuButtonRef,
                toggleSubMenu: toggleSubMenu,
                menuToggleBtn: menuToggleBtnRef,
                menuItemBtnType: hasSubMenu.value ? MenuItemType.FLYOUT : MenuItemType.DEFAULT
            });
            onCleanup(() => disposeEventListener());
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("button", {
                    ref_key: "subMenuButtonRef",
                    ref: subMenuButtonRef,
                    type: "button",
                    disabled: _ctx.option.disabled,
                    class: _normalizeClass(buttonClasses.value),
                    "aria-haspopup": hasSubMenu.value ? hasSubMenu.value : undefined,
                    "aria-expanded": hasSubMenu.value ? showSubMenu.value : undefined,
                    role: "menuitem",
                    onClick: _withModifiers(toggleOption, ["stop"])
                }, [
                    (iconType.value)
                        ? (_openBlock(), _createBlock(SvgIcon, {
                            key: 0,
                            icon: iconType.value,
                            src: "/svg/task-icons.svg",
                            class: "rec-list-item__icon"
                        }, null, 8, ["icon"]))
                        : _createCommentVNode("", true),
                    (_ctx.multiple && !hasSubMenu.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                            (_ctx.multiple && !hasSubMenu.value)
                                ? (_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    type: "checkbox",
                                    value: _ctx.option.id,
                                    checked: optionSelected.value,
                                    class: "rec-list-item__checkbox"
                                }, null, 8, _hoisted_3))
                                : _createCommentVNode("", true),
                            _createElementVNode("label", null, _toDisplayString(_ctx.option.name), 1)
                        ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(["rec-list-item__label", { 'rec-list-item__label--sub': props.parentOption }])
                        }, [
                            _createTextVNode(_toDisplayString(_ctx.option.name) + " ", 1),
                            (_ctx.option.subText)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.option.subText), 1))
                                : _createCommentVNode("", true)
                        ], 2)),
                    (hasSubMenu.value && !_ctx.option.disabled)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("div", null, [
                                _createVNode(SvgIcon, {
                                    ref: "icon",
                                    icon: "icon-arrow-right",
                                    class: "rec-flyout-indicator__chevron"
                                }, null, 512)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ], 10, _hoisted_1),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (showSubMenu.value && !_ctx.option.disabled)
                            ? (_openBlock(), _createBlock(SelectorMenu, {
                                key: 0,
                                ref_key: "subMenuRef",
                                ref: subMenuRef,
                                modelValue: subChoice.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((subChoice.value) = $event)),
                                multiple: _ctx.multiple,
                                options: _ctx.option.subOptions,
                                style: _normalizeStyle(menuStyle.value),
                                "menu-toggle-btn": _unref(subMenuButtonRef)
                            }, null, 8, ["modelValue", "multiple", "options", "style", "menu-toggle-btn"]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
